module.exports = __webpack_public_path__ + "img/sebastian-savner-venner-1.97c66064.png";